import React, { PureComponent, Fragment } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import _ from "lodash";
import { Alert, Button, Select, Spin } from "antd";

import ListContainer from "./ListContainer";
import Filter from "./FilterContainer";
import Pagination from "./PaginationContainer";
import ModalClientsManagement from "./ModalClientsManagement";
import ModalSectorsManagement from "./ModalSectorsManagement";
import ModalClientRights from "./ModalClientRights";
import ModalKpisRights from "./ModalKpisRights";
import usersFilters from "./Users.utils";
import ImportUser from "./ImportUser";
import { handleError } from "../../../modules/presence/sagas";
import FileSaver from "file-saver";
import moment from "moment";
const baseapi = process.env.REACT_APP_API + "/api";
const Option = Select.Option;

class Users extends PureComponent {
  state = {
    userClients: [],
    userSectors: [],
    userKpis: [],
    showModalClientsManagement: false,
    showModalSectorsManagement: false,
    showModalClientRights: false,
    showModalKpisRights: false,
    currentClientIndex: -1,
    currentClientId: -1,
    currentClientLabel: "",
    currentUserId: "",
    currentUserEmail: "",
    currentUserClientServices: [],
    isLoading: false,
    displayAlert: false
  };

  componentDidMount() {
    this.props.init();
  }

  componentDidUpdate(prevProps) {
    this.props.users.forEach((user, index) => {
      const { currentUserId, currentClientIndex } = this.state;

      if (user._id === currentUserId) {
        this.props.users.forEach((user, index) => {
          if (user._id === currentUserId) {
            this.setState({
              userClients: user.clients,
              userSectors: user.sectors,
              userKpis: user.kpis
            });
            if (currentClientIndex !== -1)
              this.setState({
                currentUserClientServices: user.clients[currentClientIndex].services
              });
          }
        });
      }
    });
  }

  onChangeuserRole = (userId, roleId) => {
    this.props.updateUserRole({ userId, roleId });
  };

  updateClientServiceAccess = (switchStatus, serviceId, attribut) => {
    const { currentClientId, currentUserId } = this.state;

    this.props.updateAclOfServiceClient({
      userId: currentUserId,
      clientId: currentClientId,
      serviceId: serviceId,
      status: switchStatus,
      attribut: attribut
    });
  };

  onChangeSwitchClientsManagement = (clientId, switchStatus) => {
    this.props.updateUserClients({
      clientId,
      userId: this.state.currentUserId,
      status: switchStatus
    });
  };
  onChangeSwitchKpisManagement = (kpiId, switchStatus) => {
    const { currentUserId } = this.state;

    this.props.updateUserKpi({
      kpiId,
      userId: currentUserId,
      status: switchStatus
    });
  };
  onChangeSwitchSectorsManagement = (sectorId, switchStatus) => {
    const { currentUserId } = this.state;

    this.props.updateUserSector(
      {
        sectorId,
        userId: currentUserId,
        status: switchStatus
      },
      "users"
    );
  };

  render() {
    const {
      users,
      clientsList,
      servicesList,
      aclList,
      rolesList,
      kpisList,
      currentClientLabel,
      currentClient,
      token
    } = this.props;

    return (
      <div className="p-content-page-center p-content-page-center-full">
        <div className="p-content-page-center-header">
          <h2 className="p-content-page-center-header-title">Liste des utilisateurs</h2>
          <div className="p-content-page-center-header-buttons">
            <Button
              disabled={this.state.isLoading}
              className="p-content-page-center-header-buttons-item"
              onClick={async () => {
                await this.setState({ isLoading: true });
                try {
                  await axios.get(`${baseapi}/users/updatemicrosoft`, {
                    headers: {
                      Authorization: token
                    }
                  });
                } catch (e) {
                  handleError(e);
                }
                await this.setState({ isLoading: false });
              }}
            >
              Mise à jour emails Microsoft
            </Button>
          </div>
          <div className="p-content-page-center-header-buttons">
            <Button
              disabled={this.state.isLoading}
              className="p-content-page-center-header-buttons-item"
              onClick={async () => {
                await this.setState({ isLoading: true });
                try {
                  await axios.get(`${baseapi}/users/updatelucca`, {
                    headers: {
                      Authorization: token
                    }
                  });
                } catch (e) {
                  handleError(e);
                }
                await this.setState({ isLoading: false });
              }}
            >
              Mise à jour emails Lucca
            </Button>
          </div>
        </div>
        <div className="p-content-page-center-header" style={{ marginTop: 20 }}>
          <Button
            disabled={this.state.isLoading}
            className="p-content-page-center-header-buttons-item"
            onClick={async () => {
              await this.setState({ isLoading: true });
              try {
                const response = await axios.get(`${baseapi}/users/export/lastconnexion`, {
                  responseType: "arraybuffer",
                  headers: {
                    Authorization: token
                  }
                });
                FileSaver.saveAs(
                  new Blob([response.data], { type: "application/vnd.ms-excel" }),
                  `dernieres connexions.xlsx`
                );
              } catch (e) {
                handleError(e);
              }
              await this.setState({ isLoading: false });
            }}
          >
            Dernières connexions à ES
          </Button>
          <div className="p-content-page-center-header-buttons-item">
            <ImportUser />
          </div>
        </div>
        <div className="p-content-page-center-filters">
          {usersFilters.map(filter => (
            <div key={filter.targetKey} className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={filter.targetKey}
                placeholder={filter.placeholder}
                defaultValue={
                  this.props.currentFilters[filter.defaultValue]
                    ? this.props.currentFilters[filter.defaultValue]
                    : undefined
                }
              />
            </div>
          ))}
        </div>
        <div className="p-content-page-center-content">
          {this.state.isLoading ? (
            <Spin></Spin>
          ) : (
            <ListContainer
              data={users}
              columns={[
                // {
                //   title: "Utilisateurs",
                //   key: "fullName",
                //   sortable: true,
                //   render: (text, record, index) => <div>{record.fullName}</div>
                // },
                {
                  title: "Id Lucca (Id portail2)",
                  key: "lucca_id",
                  render: (text, record, index) => (
                    <div>
                      <div>{record.lucca_id}</div>
                      <div>{record.id_portail2 ? `(${record.id_portail2})` : ""}</div>
                    </div>
                  )
                },
                {
                  title: "Email + (Email Microsoft)",
                  key: "email",
                  sortable: true,
                  render: (text, record, index) => (
                    <div>
                      <div>{record.email}</div>
                      <div>({record.microsoft_email})</div>
                    </div>
                  )
                },
                {
                  title: "Rôle",
                  sortable: true,
                  render: (text, record, index) => {
                    return (
                      <div>
                        <Select
                          value={record.role_id ? record.role_id : ""}
                          style={{ width: 100 }}
                          onChange={roleId => {
                            this.onChangeuserRole(record._id, roleId);
                          }}
                          // disabled={record.role_id === 5 ? true : false}
                        >
                          {rolesList.map(role => (
                            <Option key={role.id} value={role.id}>
                              {role.label_fr}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    );
                  }
                },
                {
                  title: "Droits",
                  key: "clients",
                  sortable: false,
                  render: (text, record, index) => {
                    const { clients } = record;

                    return (
                      <Fragment>
                        {!_.isEmpty(clients) && (
                          <ul>
                            <li>
                              KPIS
                              <span
                                className="p-users-client-icon icon-edit p-mrg-left-s"
                                onClick={() =>
                                  this.setState({
                                    showModalKpisRights: true,
                                    currentUserId: record._id,
                                    currentUserEmail: record.email
                                  })
                                }
                              />
                            </li>
                            {clients.map((client, indexClient) => {
                              return (
                                <li className="p-users-client-label" key={indexClient}>
                                  {`${client.label} (${client.id})`}
                                  <span
                                    className="p-users-client-icon icon-edit p-mrg-left-s"
                                    onClick={() =>
                                      this.setState({
                                        currentClientIndex: indexClient,
                                        currentUserClientServices: client.services,
                                        currentClientLabel: client.label,
                                        showModalClientRights: true,
                                        currentClientId: client.id,
                                        currentUserId: record._id,
                                        currentUserEmail: record.email
                                      })
                                    }
                                  />
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </Fragment>
                    );
                  }
                },
                {
                  title: "Entreprise + titre",
                  key: "lucca_legal_entity_name",
                  sortable: true,
                  render: (text, record, index) => (
                    <div>
                      <div>{record.lucca_legal_entity_name}</div>
                      <div>{record.lucca_job_title}</div>
                    </div>
                  )
                },
                {
                  title: "Effectif  + département + manager",
                  key: "lucca_department_name",
                  sortable: true,
                  render: (text, record, index) => (
                    <div>
                      <div
                        style={{
                          width: 10,
                          height: 10,
                          background: `${record.effectif ? "green" : "red"}`,
                          borderRadius: "50%"
                        }}
                      ></div>
                      <div>
                        {record.dtContractStart
                          ? `début : ${moment(record.dtContractStart).format("DD/MM/YYYY")}`
                          : null}
                      </div>
                      <div>
                        {record.dtContractEnd ? `fin : ${moment(record.dtContractEnd).format("DD/MM/YYYY")}` : null}
                      </div>
                      <div>-</div>
                      <div> {record.lucca_department_name}</div>
                      <div>-</div>
                      <div>{record.lucca_manager_name}</div>
                    </div>
                  )
                },
                {
                  title: "Actions",
                  sortable: false,
                  key: "actions",
                  render: (text, record, index) => {
                    const userClients = record.clients && record.clients.length > 0 ? record.clients : [];

                    return (
                      <Fragment key={index}>
                        <div>
                          <span
                            className="p-users-edit-icon icon-edit-user"
                            onClick={() => {
                              this.setState({
                                showModalClientsManagement: true,
                                userClients,
                                currentUserId: record._id,
                                currentUserEmail: record.email
                              });
                            }}
                          />
                          {record.role_id < 5 && (
                            <span
                              className="p-users-edit-icon icon-edit-sector p-pdg-left-s"
                              onClick={() => {
                                this.setState({
                                  userSectors: record.sectors ? record.sectors : [],
                                  showModalSectorsManagement: true,
                                  currentUserId: record._id,
                                  currentUserEmail: record.email
                                });
                              }}
                            />
                          )}
                          {record.lucca_id && (
                            <Button
                              disabled={this.state.isLoading}
                              className="p-content-page-center-header-buttons-item"
                              style={{ background: this.state.isLoading ? "#222222" : "#dddddd" }}
                              onClick={async () => {
                                await this.setState({ isLoading: true });
                                try {
                                  await axios.get(`${baseapi}/user/updatefromlucca`, {
                                    params: {
                                      email: record.email
                                    },
                                    headers: {
                                      Authorization: token
                                    }
                                  });
                                } catch (e) {
                                  handleError(e);
                                }
                                this.props.removeFilters();
                                this.props.defineFilterToSelectedUser(record.email);
                                
                                await this.setState({ isLoading: false });
                              }}
                            >
                              Mettre à jour Lucca
                            </Button>
                          )}
                        </div>
                      </Fragment>
                    );
                  }
                }
              ]}
            />
          )}
        </div>
        <div className="p-al-right p-mrg-ver p-mrg-bot-l">
          <Pagination />
        </div>
        <ModalClientsManagement
          userClients={this.state.userClients}
          showModal={this.state.showModalClientsManagement}
          user={{ email: this.state.currentUserEmail }}
          closeModal={() =>
            this.setState({
              showModalClientsManagement: false,
              userClients: []
            })
          }
          clientsList={clientsList}
          onChangeSwitchClientsManagement={this.onChangeSwitchClientsManagement}
        />
        <ModalClientRights
          updateClientServiceAccess={this.updateClientServiceAccess}
          aclList={aclList}
          servicesList={servicesList}
          user={{ email: this.state.currentUserEmail }}
          client={{ label: this.state.currentClientLabel }}
          userClientServices={this.state.currentUserClientServices}
          showModal={this.state.showModalClientRights}
          closeModal={() =>
            this.setState({
              showModalClientRights: false,
              currentClientIndex: -1
            })
          }
          onChangeSelectAclServiceClient={this.onChangeSelectAclServiceClient}
        />
        <ModalKpisRights
          userKpis={this.state.userKpis}
          kpisList={kpisList}
          showModal={this.state.showModalKpisRights}
          user={{ email: this.state.currentUserEmail }}
          closeModal={() =>
            this.setState({
              showModalKpisRights: false,
              currentClientIndex: -1
            })
          }
          onChangeSwitchKpisManagement={this.onChangeSwitchKpisManagement}
        />
        <ModalSectorsManagement
          currentClientLabel={currentClientLabel}
          currentClient={currentClient}
          sectorsList={this.props.sectorsList}
          userSectors={this.state.userSectors}
          showModal={this.state.showModalSectorsManagement}
          user={{ email: this.state.currentUserEmail }}
          userClients={this.state.userClients}
          closeModal={() =>
            this.setState({
              showModalSectorsManagement: false,
              currentClientIndex: -1
            })
          }
          onChangeSwitchSectorsManagement={this.onChangeSwitchSectorsManagement}
        />
      </div>
    );
  }
}

Users.propTypes = {
  users: PropTypes.array,
  client: PropTypes.array,
  init: PropTypes.function,
  updateUserClients: PropTypes.function
};

export default Users;



// WEBPACK FOOTER //
// src/containers/admin/users/Users.js